import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';
import getObjectTransformer from '../util/getObjectTransformer';

import axios from 'axios';
import PendingQueries from '../singletons/PendingQueries';
import User from '../singletons/User';

import Requests from './requests';
import reportError from '../util/reportError';
import {ValidationError} from 'yup';
import configBuilder from './requests/config-builder';

const fromApi = getObjectTransformer(camelCase);

const convertEmptyStringToNull = (v) => (v === '' ? null : v);

/*
  _id is for mongo;
*/
const toApiNormal = getObjectTransformer(
  (k) => (k === 'id' ? '_id' : snakeCase(k)),
  convertEmptyStringToNull,
);

const toApiWithoutSnake = getObjectTransformer(
  (k) => (k === 'id' ? '_id' : k),
  convertEmptyStringToNull,
);

const deepestData = (response) => {
  while (response?.data) {
    response = response?.data;
  }
  return response;
}

async function makeQuery(fetchType, params) {
  const request = Requests[fetchType];

  if (!request) {
    throw new Error('No request for fetch type: ' + fetchType);
  }

  const baseURL = process.env.REACT_APP_API_URL;

  const {
    url: getUrl,
    method,
    getBody,
    Schema,
    doNotConvertKeysToSnakeCase,
  } = request;

  /*
    actions should not be called inside component observers.
    makeQuery is often used in pair with onBecomeObserved, which happens inside render.
    to avoid react errors, PendingQueries.add must be performed asynchronously
  */

  let queryId;

  try {
    await Schema.validate(params);
    queryId = PendingQueries.add(fetchType, params);
    const toApi = doNotConvertKeysToSnakeCase ? toApiWithoutSnake : toApiNormal;
    const {token} = User.auth;
    const response = await axios({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token && `Bearer ${token}`,
        },
        method,
        baseURL,
        url: getUrl(params),
        data: toApi(getBody(params)),
        ...configBuilder(params)
      });
    return fromApi(deepestData(response));
  } catch (e) {
    if (e instanceof ValidationError) {
      console.warn('Query params: ', params, 'Error path: ', e.path);
      console.dir(e);
      reportError('PROMISE', `Error during query validation: ${fetchType}`);
    } else throw e;
  } finally {
    PendingQueries.remove(fetchType, queryId);
  }
}

export default makeQuery;
